/* pg-pdp.js — Phos & Gaia PDP redesign
   Variants, quantity, running total, delivery date, sticky ATC, wishlist, lightbox.
   ΤΙΜΕΣ: δεν φτιάχνουμε δική μας μορφοποίηση — διαβάζουμε το μοτίβο από την
   τιμή που έγραψε το Liquid (money_format του καταστήματος) και το αναπαράγουμε. */
(function () {
  var root = document.querySelector('[data-pg-pdp]');
  if (!root) return;

  (function loadFonts() {
    var href = 'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Montserrat:wght@400;500;600;700;800&display=swap';
    if (document.querySelector('link[data-pg-fonts]')) return;
    var pre = document.createElement('link');
    pre.rel = 'preconnect'; pre.href = 'https://fonts.gstatic.com'; pre.crossOrigin = '';
    document.head.appendChild(pre);
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = href; l.setAttribute('data-pg-fonts', '');
    document.head.appendChild(l);
  })();

  var MONTHS = ['Ιανουαρίου','Φεβρουαρίου','Μαρτίου','Απριλίου','Μαΐου','Ιουνίου','Ιουλίου','Αυγούστου','Σεπτεμβρίου','Οκτωβρίου','Νοεμβρίου','Δεκεμβρίου'];
  var cfg = window.PG_PDP || {};
  var variants = [];
  try {
    variants = JSON.parse(document.querySelector('[data-pg-variants]').textContent);
  } catch (e) {}

  /* ---------- money: μιμούμαστε το format του καταστήματος ---------- */
  var money = (function () {
    var seed = '';
    var el = root.querySelector('.pg-price__now') || root.querySelector('[data-pg-sticky-price]');
    if (el) seed = (el.textContent || '').trim();

    var pre = '', post = '', dec = ',', thou = '.', gap = ' ';
    var m = seed.match(/^([^0-9]*?)\s*([0-9][0-9.,\s]*)\s*([^0-9]*)$/);
    if (m) {
      pre = (m[1] || '').trim();
      post = (m[3] || '').trim();
      var num = (m[2] || '').replace(/\s/g, '');
      var lastDot = num.lastIndexOf('.');
      var lastComma = num.lastIndexOf(',');
      if (lastDot > lastComma) { dec = '.'; thou = lastComma > -1 ? ',' : ''; }
      else if (lastComma > lastDot) { dec = ','; thou = lastDot > -1 ? '.' : ''; }
      else { dec = lastDot > -1 ? '.' : ','; thou = ''; }
      if (pre && /^[^0-9]+\S/.test(seed) && seed.indexOf(pre + ' ') !== 0) gap = '';
    }

    return function (cents) {
      var v = (Math.round(cents) / 100).toFixed(2).split('.');
      var int = v[0];
      if (thou) int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      var out = int + dec + v[1];
      if (pre) out = pre + gap + out;
      if (post) out = out + ' ' + post;
      return out;
    };
  })();

  /* ---------- delivery estimate ---------- */
  function addBiz(days) {
    var d = new Date();
    if (d.getHours() >= 14) days += 1;
    var left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) left--;
    }
    return d;
  }
  function renderDelivery() {
    var el = root.querySelector('[data-pg-delivery-range]');
    if (!el) return;
    var proc = parseInt(cfg.processingDays, 10); if (isNaN(proc)) proc = 1;
    var min = parseInt(cfg.transitMin, 10); if (isNaN(min)) min = 1;
    var max = parseInt(cfg.transitMax, 10); if (isNaN(max)) max = 3;
    var a = addBiz(proc + min), b = addBiz(proc + max);
    el.textContent = a.getMonth() === b.getMonth()
      ? a.getDate() + '–' + b.getDate() + ' ' + MONTHS[b.getMonth()]
      : a.getDate() + ' ' + MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
  }

  /* ---------- variants ---------- */
  function selectedOptions() {
    return Array.prototype.map.call(root.querySelectorAll('.pg-option'), function (opt) {
      var checked = opt.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }
  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] && v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function updateVariant() {
    var opts = selectedOptions();
    var v = findVariant(opts);
    if (!v) return;
    root.dataset.variantId = v.id;
    var input = root.querySelector('[data-pg-variant-input]');
    if (input) input.value = v.id;
    root.querySelectorAll('.pg-option').forEach(function (opt, i) {
      var label = opt.querySelector('[data-pg-option-value]');
      if (label && opts[i]) label.textContent = opts[i];
    });
    var now = root.querySelector('.pg-price__now');
    if (now) now.textContent = money(v.price);
    var was = root.querySelector('.pg-price__was');
    if (was) was.textContent = v.compare_at_price ? money(v.compare_at_price) : '';
    updateTotal();
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* ---------- quantity ---------- */
  function qtyInput() { return root.querySelector('[data-pg-qty-input]'); }
  function setQty(n) {
    var val = Math.max(1, n || 1);
    var inputs = root.querySelectorAll('[data-pg-qty-input]');
    for (var i = 0; i < inputs.length; i++) inputs[i].value = val;
    updateTotal();
  }
  function currentVariant() {
    var id = parseInt(root.dataset.variantId, 10);
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return variants[0];
  }
  function updateTotal() {
    var v = currentVariant();
    if (!v) return;
    var q = parseInt(qtyInput() ? qtyInput().value : 1, 10) || 1;
    var total = money(v.price * q);
    var t = root.querySelector('[data-pg-total]');
    if (t) t.textContent = total;
    var sp = root.querySelector('[data-pg-sticky-price]');
    if (sp) sp.textContent = total;
  }

  /* ---------- wishlist → Klaviyo ---------- */
  function klaviyoBtn() {
    var blocks = root.querySelectorAll('.pg-appblock');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      var mark = b.querySelector('button, [role="button"], a[href*="wishlist"]');
      if (!mark) continue;
      var probe = (b.className + ' ' + b.innerHTML).toLowerCase();
      if (probe.indexOf('klaviyo') > -1 || probe.indexOf('wishlist') > -1 || probe.indexOf('favorite') > -1) return mark;
    }
    return null;
  }

  root.addEventListener('change', function (ev) {
    if (ev.target.matches('input[type="radio"][name^="pg-option-"]')) updateVariant();
    if (ev.target.matches('[data-pg-qty-input]')) setQty(parseInt(ev.target.value, 10));
  });
  root.addEventListener('click', function (ev) {
    var step = ev.target.closest('[data-pg-qty]');
    if (step) {
      var box = step.closest('[data-pg-stepper]');
      var i = box ? box.querySelector('[data-pg-qty-input]') : qtyInput();
      setQty((parseInt(i.value, 10) || 1) + parseInt(step.dataset.pgQty, 10));
    }
    var wish = ev.target.closest('[data-pg-wish]');
    if (wish) {
      var kb = klaviyoBtn();
      if (kb) kb.click();
      document.dispatchEvent(new CustomEvent('pg:wishlist', { detail: { variantId: root.dataset.variantId } }));
    }
  });

  /* the theme's media scripts can swallow gallery clicks — capture phase opens the lightbox */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (!t.closest('[data-pg-pdp]')) return;
    var hit = t.closest('[data-pg-zoom]') || t.closest('[data-pg-cell]');
    if (!hit) return;
    if (t.closest('[data-pg-wish]')) return;
    ev.preventDefault();
    ev.stopPropagation();
    var idx = hit.hasAttribute('data-pg-cell') ? parseInt(hit.getAttribute('data-pg-cell'), 10) : 0;
    openLb(idx || 0);
  }, true);

  /* ---------- lightbox ---------- */
  var lb = null, lbSlides = [], lbThumbs = [], lbIndexEl = null, lbIndex = 0, lbReturn = null;

  function srcOf(img) {
    var cands = [img.currentSrc, img.getAttribute('src'), img.getAttribute('data-src'),
                 img.getAttribute('data-original'), img.getAttribute('data-lazy-src')];
    for (var i = 0; i < cands.length; i++) {
      var s = cands[i];
      if (s && s.indexOf('data:') !== 0 && s.indexOf('blank.') === -1) return s;
    }
    var ss = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    if (ss) {
      var parts = ss.split(',');
      var last = parts[parts.length - 1].trim().split(' ')[0];
      if (last) return last;
    }
    return '';
  }
  function sized(img, w) {
    var s = srcOf(img);
    if (!s) return '';
    if (s.indexOf('width=') > -1) return s.replace(/([?&]width=)\d+/, '$1' + w);
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function buildLb() {
    var imgs = root.querySelectorAll('.pg-gallery__img');
    if (!imgs.length) return null;
    var slides = '', thumbs = '', usable = 0;
    for (var i = 0; i < imgs.length; i++) {
      var big = sized(imgs[i], 1600), small = sized(imgs[i], 160);
      if (!big) continue;
      usable++;
      var alt = (imgs[i].getAttribute('alt') || '').replace(/"/g, '&quot;');
      slides += '<figure class="pg-lb__slide" data-pg-lb-slide="' + i + '"' + (i === 0 ? ' data-current' : '') +
        '><img data-src="' + big + '" alt="' + alt + '" decoding="async"></figure>';
      thumbs += '<button type="button" class="pg-lb__thumb" data-pg-lb-go="' + i + '" aria-current="' +
        (i === 0 ? 'true' : 'false') + '" aria-label="Εικόνα ' + (i + 1) + '">' +
        '<img src="' + small + '" alt="" loading="lazy" decoding="async"></button>';
    }
    if (!usable) return null;

    var el = document.createElement('div');
    el.className = 'pg-lb';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Προβολή εικόνων προϊόντος');
    el.innerHTML =
      '<div class="pg-lb__bar">' +
        '<span class="pg-lb__count"><span data-pg-lb-index>1</span> / ' + usable + '</span>' +
        '<button type="button" data-pg-lb-close aria-label="Κλείσιμο">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="pg-lb__stage" data-pg-lb-stage>' +
        '<button type="button" class="pg-lb__nav pg-lb__nav--prev" data-pg-lb-step="-1" aria-label="Προηγούμενη εικόνα">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M14.5 5 8 12l6.5 7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' + slides +
        '<button type="button" class="pg-lb__nav pg-lb__nav--next" data-pg-lb-step="1" aria-label="Επόμενη εικόνα">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9.5 5 16 12l-6.5 7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="pg-lb__foot"><div class="pg-lb__thumbs">' + thumbs + '</div></div>';
    document.body.appendChild(el);

    lbSlides = el.querySelectorAll('[data-pg-lb-slide]');
    lbThumbs = el.querySelectorAll('[data-pg-lb-go]');
    lbIndexEl = el.querySelector('[data-pg-lb-index]');
    el.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-pg-lb-close]')) return closeLb();
      var step = ev.target.closest('[data-pg-lb-step]');
      if (step) return showLb(lbIndex + parseInt(step.dataset.pgLbStep, 10));
      var go = ev.target.closest('[data-pg-lb-go]');
      if (go) return showLb(indexOfSlide(go.dataset.pgLbGo));
      if (ev.target === el || ev.target.matches('.pg-lb__stage, .pg-lb__foot')) closeLb();
    });
    return el;
  }

  function indexOfSlide(cellIndex) {
    for (var i = 0; i < lbSlides.length; i++) {
      if (lbSlides[i].getAttribute('data-pg-lb-slide') === String(cellIndex)) return i;
    }
    return 0;
  }
  function loadSlide(i) {
    if (i < 0 || i >= lbSlides.length) return;
    var img = lbSlides[i].querySelector('img');
    if (img && !img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
  }
  function showLb(i) {
    if (!lbSlides.length) return;
    lbIndex = (i + lbSlides.length) % lbSlides.length;
    for (var s = 0; s < lbSlides.length; s++) {
      if (s === lbIndex) lbSlides[s].setAttribute('data-current', '');
      else lbSlides[s].removeAttribute('data-current');
    }
    for (var t = 0; t < lbThumbs.length; t++) {
      lbThumbs[t].setAttribute('aria-current', t === lbIndex ? 'true' : 'false');
    }
    loadSlide(lbIndex); loadSlide(lbIndex + 1); loadSlide(lbIndex - 1);
    if (lbIndexEl) lbIndexEl.textContent = String(lbIndex + 1);
  }
  function openLb(cellIndex) {
    if (!lb) lb = buildLb();
    if (!lb || !lb.hidden) return;
    lbReturn = document.activeElement;
    lb.hidden = false;
    document.documentElement.classList.add('pg-lb-open');
    showLb(indexOfSlide(cellIndex));
    var close = lb.querySelector('[data-pg-lb-close]');
    if (close) close.focus();
  }
  function closeLb() {
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.documentElement.classList.remove('pg-lb-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (lbReturn && lbReturn.focus) lbReturn.focus();
  }
  document.addEventListener('keydown', function (ev) {
    if (!lb || lb.hidden) return;
    if (ev.key === 'Escape') closeLb();
    else if (ev.key === 'ArrowRight') showLb(lbIndex + 1);
    else if (ev.key === 'ArrowLeft') showLb(lbIndex - 1);
  });

  /* ---------- sticky ATC ---------- */
  var sticky = root.querySelector('[data-pg-sticky]');
  if (sticky) {
    var atc = root.querySelector('[data-pg-atc]');
    var onScroll = function () {
      if (!atc) return;
      sticky.hidden = !(atc.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  renderDelivery();
  updateTotal();
})();
